module.exports = {
  __init__: [ 'bpmnAutoResize', 'bpmnAutoResizeProvider' ],
  bpmnAutoResize: [ 'type', require(8) ],
  bpmnAutoResizeProvider: [ 'type', require(9) ]
};
